import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import type { TranslationConfig } from '../i18n-cache';
import { promotionsRouteI18n } from '../i18n/promotions-i18n';

export function promotionsRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${promotionsRouteI18n(config)}`;
}
